import React, { useContext } from 'react';
import { AppContext } from '../../AppContext';
import { useExcludedContactsQuery } from '../../generated/graphql';
import DenseTable from '../Common/Tables/DenseTable';

const ExcludedRecipients: React.FunctionComponent = () => {
  const { state } = useContext(AppContext);
  const excludedContacts = useExcludedContactsQuery({
    variables: {
      id: parseInt(state.selectedRecipientList?.id as string)
    },
    fetchPolicy: 'no-cache'
  });

  const columns = [
    {
      title: 'First Name',
      width: 350,
      field: 'first_name'
    },
    {
      title: 'Last Name',
      width: 350,
      field: 'last_name'
    },
    {
      title: 'Title',
      width: 268,
      field: 'titleInternal.name'
    },
    {
      title: 'Email',
      width: 373,
      field: 'email'
    }
  ];

  return (
    <DenseTable
      columns={columns}
      data={excludedContacts.data?.result || []}
      loading={excludedContacts.loading}
      handleDetails={() => true}
      handleRemove={() => true}
      pageSize={15}
      removeButtonStyle={'minus'}
      title={`${excludedContacts.data?.result.length ?? 0} Excluded Recipients`}
    />
  );
};

export default ExcludedRecipients;
